import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DropdownMenu } from '@3plearning/react-components';
import { CLASS_LIST, ALL_CLASSES } from '../filter-constants';
import { dropdownItemPropType } from '../filter-prop-types';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';
import {
    getTranslatedOptions,
    getTranslateSelectedOption
} from './dropdown-helpers';

export class ClassDropdown extends PureComponent {
    static propTypes = {
        classDropdownData: PropTypes.shape({
            data: PropTypes.arrayOf(dropdownItemPropType),
            selectedOption: dropdownItemPropType,
            disabled: PropTypes.bool
        }),
        className: PropTypes.string,
        setSelectedClass: PropTypes.func,
        handleClassChange: PropTypes.func
    };

    optionSelected = (selectedOption) => {
        const { setSelectedClass, handleClassChange } = this.props;
        setSelectedClass(selectedOption);
        handleClassChange();
    };

    render() {
        const { classDropdownData, className } = this.props;
        const { data, selectedOption, disabled } = classDropdownData;
        const i18n = window.i18n;

        return (
            <DropdownMenu
                className={className}
                options={getTranslatedOptions(data, ALL_CLASSES, i18n)}
                selectedOption={getTranslateSelectedOption(
                    selectedOption,
                    ALL_CLASSES,
                    i18n
                )}
                onSelectOption={this.optionSelected}
                disabled={disabled}
            />
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        classDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            CLASS_LIST
        )(state)
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setSelectedClass: dropdownDataActions.setSelectedClass },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/class-dropdown.js